import React from 'react';
import { Change } from '../Change';
import { addCommasToNumber } from '../../../Utils/CommonUtils';

interface RATES_PROPS {
  image: string;
  rate: number;
  change: number;
  sign: string;
}

export const SilverRates = ({
  image,
  rate,
  change,
  sign,
}: RATES_PROPS): JSX.Element => {
  return (
    <>
      <div className="flex items-center gap-4 mr-6 sm:flex-col sm:border sm:border-[#EBEBEC] w-full sm:p-3 rounded-md sm:items-center sm:gap-2">
        <img src={image} alt="" width={88} height={30} className="h-8 w-auto" />
        <div className="flex flex-col items-start">
          <div className="flex gap-4 w-full items-baseline sm:justify-center">
            <div className="font-bold text-s-40 text-font-700 sm:text-s-24">
              ₹{addCommasToNumber(Math.floor(rate))}
            </div>
            <Change sign={sign} change={Math.floor(change)} />
          </div>
        </div>
      </div>
    </>
  );
};
